/**
 * Compares two payloads for deep equality. This assumes payloads are simple deserialized JSON
 * objects where data only includes primitive types & objects.
 * @param payload1 payload to compare
 * @param payload2 payload to compare
 * @returns {boolean} true if deeply equal, false otherwise
 */
export default function isPayloadEqual(payload1: any, payload2: any): boolean {
    if (payload1 === payload2) {
        return true;
    }

    if (payload1 instanceof Object && payload2 instanceof Object) {
        if (Object.keys(payload1).length !== Object.keys(payload2).length) {
            return false;
        }

        for (const key of Object.keys(payload1)) {
            const val1 = payload1[key];
            const val2 = payload2[key];
            if (!payload2.hasOwnProperty(key) || !isPayloadEqual(val1, val2)) {
                return false;
            }
        }

        return true;
    }

    return false;
}
